import React from "react";
import { useTranslation } from "react-i18next";
import { EC } from "../../utils/const/ecommerce-colors-const";

const SIGNUP_STEPS = [
    { number: 1, labelKey: "ct_signup_step1" },
    { number: 2, labelKey: "ct_signup_step2" },
];

function getStepCircleClass(stepNumber, currentStep) {
    if (stepNumber === currentStep) return EC.form.stepActive;
    if (stepNumber < currentStep) return EC.form.stepDone;
    return EC.form.stepInactive;
}

function SignUpStepItem({ stepNumber, label, currentStep, isLastStep }) {
    const isConnectorFilled = currentStep > stepNumber;

    return (
        <div className="flex flex-1 items-center gap-2">
            <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${getStepCircleClass(stepNumber, currentStep)}`}
                aria-current={stepNumber === currentStep ? "step" : undefined}
            >
                {stepNumber}
            </span>

            <span className="hidden text-xs font-medium text-slate-600 xs:inline sm:text-sm">
                {label}
            </span>

            {!isLastStep && (
                <div
                    className={`h-0.5 flex-1 ${isConnectorFilled ? "bg-ct-primary-400" : "bg-slate-200"}`}
                    aria-hidden
                />
            )}
        </div>
    );
}

/**
 * Two-step signup progress: (1) Company info → (2) Account.
 * Highlights the current step and marks completed steps.
 */
export default function SignUpStepProgress({ currentStep }) {
    const { t } = useTranslation();

    return (
        <nav className="mb-6" aria-label={t("ct_signup_progress_label")}>
            <ol className="flex items-center gap-2">
                {SIGNUP_STEPS.map((step, index) => (
                    <li key={step.number} className="flex flex-1 items-center">
                        <SignUpStepItem
                            stepNumber={step.number}
                            label={t(step.labelKey)}
                            currentStep={currentStep}
                            isLastStep={index === SIGNUP_STEPS.length - 1}
                        />
                    </li>
                ))}
            </ol>
        </nav>
    );
}
